export const EnchantableItem = ({
    enchanted,
    onClick,
}: {
    enchanted: { id: number; name: string; level: number; grade: number; category2: string };
    onClick: () => void;
}) => {
    if (!enchanted?.name) return null;
    return (
        <ul className="topborder">
            <li>
                <div className="key">강화 가능</div>
                <div className="value">
                    <button data-detailshow={enchanted.id} data-itemgrade={enchanted.grade} onClick={onClick}>
                        {enchanted.name}
                    </button>
                </div>
            </li>
        </ul>
    );
};
